__turbopack_context__.v({
  "externalIcon": "U5i1fW_externalIcon",
  "link": "U5i1fW_link",
  "linkInherit": "U5i1fW_linkInherit",
  "linkLg": "U5i1fW_linkLg",
  "linkMd": "U5i1fW_linkMd",
  "linkSm": "U5i1fW_linkSm",
  "textLink": "U5i1fW_textLink",
  "underlineHover": "U5i1fW_underlineHover",
});
